import { render, staticRenderFns } from "./AppGlobalSearch.vue?vue&type=template&id=1238dc20&scoped=true&"
import script from "./AppGlobalSearch.vue?vue&type=script&lang=ts&"
export * from "./AppGlobalSearch.vue?vue&type=script&lang=ts&"
import style0 from "./AppGlobalSearch.vue?vue&type=style&index=0&id=1238dc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1238dc20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VImg,VTextField})
